// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1fwZ3","selected":"Chip_selected__1_B2d"};